<template>
  <ReactPage>
    <summarize-consumer-report-page></summarize-consumer-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from "../components/ReactPage.vue";

export default {
  name: "SummarizeConsumerReport",
  components: {
    ReactPage,
  },
};
</script>
